<app-debug-footer-panel></app-debug-footer-panel>
<div class="footer">{{ year }} © Quotiss.</div>
